import React from "react";
import { message } from "antd";

import { DeleteIcon } from "src/components";
import { compose } from "src/helpers";
import { withDeleteDocument } from "src/modules/document/operations";
import { captureException } from "@sentry/react";

const DeleteView = (props) => {
    const { deleteDocument, id } = props;

    const handleDelete = async () => {
        try {
            await deleteDocument(id);
            message.success("Deleted!");
        } catch (err) {
            captureException(err)
            message.error("Failed!");
        }
    };

    return <DeleteIcon {...props} onConfirm={handleDelete} />;
};

export default compose(withDeleteDocument)(DeleteView);
